/** html2canvas 오프스크린 캡처용 — 평가 기준안 웹 문서 */
export const EVALUATION_PLAN_WEB_DOCUMENT_CAPTURE_CSS = `
.cp-evaluation-plan-web-doc-export-root {
  display: block !important;
  width: 100% !important;
  background: #fff !important;
  overflow: visible !important;
}
.cp-evaluation-plan-web-doc-page {
  width: 100% !important;
  max-width: 794px !important;
  height: 297mm !important;
  min-height: 297mm !important;
  margin: 0 auto !important;
  aspect-ratio: 210 / 297 !important;
  overflow: visible !important;
  box-shadow: none !important;
  --cp-web-doc-row-unit: 44px;
  --cp-web-doc-row-unit-h1: 34px;
  --cp-web-doc-header-unit: 30px;
  --cp-web-doc-example-body-min: 30px;
  padding: 28px 32px 36px !important;
  border: 1px solid #cfcfcf !important;
  border-radius: 2px !important;
  background: #fff !important;
  color: #111 !important;
  box-sizing: border-box !important;
  display: flex !important;
  flex-direction: column !important;
}
.cp-evaluation-plan-web-doc-page-main {
  flex: none !important;
  min-height: 0 !important;
  overflow: visible !important;
  display: flex !important;
  flex-direction: column !important;
}
.cp-evaluation-plan-web-doc-title-row {
  margin-bottom: 10px !important;
  width: 100% !important;
}
.cp-evaluation-plan-web-doc-title-badge {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  padding: 8px 22px !important;
  border-radius: 10px !important;
  background: #e8e8e8 !important;
  box-sizing: border-box !important;
}
.cp-evaluation-plan-web-doc-title-badge.has-page-badge {
  position: relative !important;
  padding-right: 48px !important;
}
.cp-learning-worksheet-title-page-badge {
  position: absolute !important;
  right: 10px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  width: 30px !important;
  height: 30px !important;
  border-radius: 50% !important;
  background: #ffffff !important;
  color: #111111 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-size: 0.82rem !important;
  font-weight: 700 !important;
  line-height: 1 !important;
  box-sizing: border-box !important;
}
.cp-evaluation-plan-web-doc-title-readonly {
  width: 100% !important;
  text-align: center !important;
  font-size: 1.35rem !important;
  font-weight: 700 !important;
  letter-spacing: 0.02em !important;
  line-height: 1.3 !important;
}
.cp-evaluation-plan-web-doc-school-year-line {
  margin: 0 0 12px !important;
  padding: 0 2px !important;
  text-align: left !important;
  font-size: 0.82rem !important;
  font-weight: 600 !important;
  line-height: 1.3 !important;
}
.cp-learning-worksheet-school-year-row {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  gap: 12px !important;
  margin: 0 0 12px !important;
  padding: 0 2px !important;
  font-size: 1.02rem !important;
  font-weight: 700 !important;
  line-height: 1.35 !important;
  color: #8a8a8a !important;
}
.cp-learning-worksheet-school-year-label {
  flex: 0 0 auto !important;
  text-align: left !important;
  font-weight: 700 !important;
}
.cp-learning-worksheet-student-info-fields {
  display: flex !important;
  align-items: center !important;
  justify-content: flex-end !important;
  gap: 1.35rem !important;
  flex: 1 1 auto !important;
}
.cp-learning-worksheet-student-info-item {
  display: inline-flex !important;
  align-items: center !important;
  gap: 0.4rem !important;
}
.cp-learning-worksheet-student-info-item--label-first {
  gap: 0.45rem !important;
}
.cp-learning-worksheet-student-info-label {
  white-space: nowrap !important;
  font-weight: 700 !important;
}
.cp-learning-worksheet-student-info-blank {
  display: inline-block !important;
  box-sizing: border-box !important;
  border: 1.5px solid #b0b0b0 !important;
  border-radius: 6px !important;
  background: #fff !important;
  height: 1.35em !important;
  min-height: 20px !important;
  vertical-align: middle !important;
}
.cp-learning-worksheet-student-info-blank--grade {
  width: 2.5rem !important;
}
.cp-learning-worksheet-student-info-blank--class {
  width: 3rem !important;
}
.cp-learning-worksheet-student-info-blank--number {
  width: 3rem !important;
}
.cp-learning-worksheet-student-info-blank--name {
  width: 7.5rem !important;
}
.cp-evaluation-plan-web-doc-table {
  width: 100% !important;
  border-collapse: collapse !important;
  table-layout: fixed !important;
  font-size: 0.82rem !important;
  line-height: 1.35 !important;
}
.cp-evaluation-plan-web-doc-table th,
.cp-evaluation-plan-web-doc-table td {
  border: 1px solid #333 !important;
  padding: 0 !important;
  vertical-align: top !important;
}
.cp-evaluation-plan-web-doc-label-cell,
.cp-evaluation-plan-web-doc-row-label-cell,
.cp-evaluation-plan-web-doc-head-cell {
  background: #ececec !important;
  font-weight: 700 !important;
  text-align: center !important;
  vertical-align: middle !important;
}
.cp-evaluation-plan-web-doc-value-cell,
.cp-evaluation-plan-web-doc-data-cell {
  background: #fff !important;
}
.cp-evaluation-plan-web-doc-col-label {
  width: 15% !important;
}
.cp-evaluation-plan-web-doc-col-value {
  width: 35% !important;
}
.cp-evaluation-plan-web-doc-gubun-col {
  width: 15% !important;
}
.cp-evaluation-plan-web-doc-cell-readonly {
  display: block !important;
  width: 100% !important;
  box-sizing: border-box !important;
  padding: 5px 8px !important;
  white-space: pre-wrap !important;
  word-break: break-word !important;
  line-height: 1.35 !important;
  color: #111 !important;
}
.cp-evaluation-plan-web-doc-head-label,
.cp-evaluation-plan-web-doc-row-label {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  min-height: var(--cp-web-doc-row-unit) !important;
  box-sizing: border-box !important;
  padding: 4px 6px !important;
  text-align: center !important;
}
.cp-evaluation-plan-web-doc-row-h-1 .cp-evaluation-plan-web-doc-head-label,
.cp-evaluation-plan-web-doc-row-h-1 .cp-evaluation-plan-web-doc-row-label {
  min-height: var(--cp-web-doc-row-unit-h1) !important;
}
.cp-evaluation-plan-web-doc-row-h-2 .cp-evaluation-plan-web-doc-head-label,
.cp-evaluation-plan-web-doc-row-h-2 .cp-evaluation-plan-web-doc-row-label {
  min-height: calc(var(--cp-web-doc-row-unit) * 2) !important;
}
.cp-evaluation-plan-web-doc-dual-label {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  gap: 2px !important;
  width: 100% !important;
  text-align: center !important;
  min-height: calc(var(--cp-web-doc-row-unit) * 2) !important;
  justify-content: center !important;
}
.cp-evaluation-plan-web-doc-dual-label-line {
  display: block !important;
  width: 100% !important;
  line-height: 1.25 !important;
  text-align: center !important;
}
.cp-evaluation-plan-web-doc-example-answer-section {
  overflow: hidden !important;
  flex: 1 1 auto !important;
  min-height: 0 !important;
  display: flex !important;
  flex-direction: column !important;
  border-left: 1px solid #333 !important;
  border-right: 1px solid #333 !important;
  font-size: 0.82rem !important;
  line-height: 1.4 !important;
}
.cp-evaluation-plan-web-doc-example-answer-header {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  min-height: var(--cp-web-doc-header-unit) !important;
  padding: 4px 6px !important;
  border-top: 1px solid #333 !important;
  border-bottom: 1px solid #333 !important;
  background: #ececec !important;
  font-weight: 700 !important;
  text-align: center !important;
}
.cp-evaluation-plan-web-doc-example-answer-body {
  overflow: hidden !important;
  flex: 1 1 auto !important;
  min-height: 0 !important;
  display: flex !important;
  flex-direction: column !important;
  border-bottom: 1px solid #333 !important;
  background: #fff !important;
}
.cp-evaluation-plan-web-doc-example-answer-readonly,
.cp-evaluation-plan-web-doc-example-answer-input-shell,
.cp-evaluation-plan-web-doc-example-answer-body .cp-evaluation-plan-web-doc-cell-input-shell {
  flex: 1 1 auto !important;
  min-height: 100% !important;
  height: 100% !important;
  box-sizing: border-box !important;
}
.cp-evaluation-plan-web-doc-gubun-cell-inner {
  display: flex !important;
  flex-direction: column !important;
  min-height: calc(var(--cp-web-doc-row-unit) * 2) !important;
}
.cp-evaluation-plan-web-doc-row-h-1 .cp-evaluation-plan-web-doc-gubun-cell-inner {
  min-height: var(--cp-web-doc-row-unit-h1) !important;
}
.cp-evaluation-plan-web-doc-gubun-memo-readonly {
  padding-top: 4px !important;
  font-size: 0.78rem !important;
  color: #6f6f6f !important;
  text-align: center !important;
}
.cp-evaluation-plan-web-doc-rubric-table {
  margin-top: -1px !important;
}

/* 평가 기준안: 윗표 라벨 세로 가운데 · 유의사항 행 절반 높이 · 아랫표 머리행 = '평가 과제' 제목줄 높이 (편집기·보기·인쇄 공통) */
.cp-evaluation-plan-web-doc-table .cp-evaluation-plan-web-doc-label-cell {
  vertical-align: middle !important;
}
.cp-evaluation-plan-web-doc-label-cell > .cp-evaluation-plan-web-doc-head-label,
.cp-evaluation-plan-web-doc-label-cell > .cp-evaluation-plan-web-doc-dual-label,
.cp-evaluation-plan-web-doc-label-cell > .cp-evaluation-plan-web-doc-title-cell-inner,
.cp-evaluation-plan-web-doc-label-cell > .cp-wd-hover {
  display: flex !important;
  flex-direction: column;
  align-items: center !important;
  justify-content: center !important;
  min-height: 0 !important;
}
.cp-wd-notice-row .cp-evaluation-plan-web-doc-value-cell,
.cp-wd-notice-row .cp-evaluation-plan-web-doc-value-cell .cp-evaluation-plan-web-doc-cell-input-shell,
.cp-wd-notice-row .cp-evaluation-plan-web-doc-label-cell > * {
  min-height: var(--cp-web-doc-row-unit) !important;
  height: auto !important;
}
.cp-evaluation-plan-web-doc-rubric-head-row > th {
  height: var(--cp-web-doc-header-unit) !important;
  min-height: 0 !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  vertical-align: middle !important;
  box-sizing: border-box;
}
.cp-evaluation-plan-web-doc-rubric-head-row > th > * {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  min-height: 0 !important;
  height: auto !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.cp-evaluation-plan-web-doc-rubric-head-row .cp-evaluation-plan-web-doc-head-label {
  min-height: 0 !important;
  line-height: 1.3;
}
`;
